var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnInformationCircle = function SvgIcnInformationCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 8.0001C14.4001 11.5347 11.5347 14.4001 8.00011 14.4001C4.46548 14.4001 1.6001 11.5347 1.6001 8.0001C1.6001 4.46548 4.46548 1.6001 8.00011 1.6001C11.5347 1.6001 14.4001 4.46548 14.4001 8.0001ZM8.80011 4.8001C8.80011 5.24193 8.44194 5.6001 8.00011 5.6001C7.55828 5.6001 7.20011 5.24193 7.20011 4.8001C7.20011 4.35827 7.55828 4.0001 8.00011 4.0001C8.44194 4.0001 8.80011 4.35827 8.80011 4.8001ZM7.20011 7.2001C6.75828 7.2001 6.4001 7.55827 6.4001 8.0001C6.4001 8.44193 6.75828 8.8001 7.20011 8.8001V11.2001C7.20011 11.6419 7.55828 12.0001 8.00011 12.0001H8.80011C9.24194 12.0001 9.60011 11.6419 9.60011 11.2001C9.60011 10.7583 9.24194 10.4001 8.80011 10.4001V8.0001C8.80011 7.55827 8.44194 7.2001 8.00011 7.2001H7.20011Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnInformationCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_information_circle.532b002f.svg";
export { ForwardRef as ReactComponent };